import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { startSessionTimeout, clearSessionTimeout } from '../../services/api';

interface AuthState {
  isAuthenticated: boolean;
  isInitialized: boolean;
  user: {
    id?: number;
    email?: string;
    username?: string;
    firstName?: string;
    lastName?: string;
    companyID?: string;
    companyName?: string;
    roles?: string;
    phoneNumber?: string;
    isDisabled?: boolean;
    isLockedOut?: boolean;
  } | null;
}

const initialState: AuthState = {
  isAuthenticated: false,
  isInitialized: false,
  user: null,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<AuthState['user']>) => {
      state.user = action.payload;
      state.isAuthenticated = true;
      // Store auth state in localStorage for persistence
      if (action.payload) {
        localStorage.setItem('auth', JSON.stringify({
          user: action.payload,
          isAuthenticated: true
        }));
      }
      startSessionTimeout();
    },
    logOut: (state) => {
      state.user = null;
      state.isAuthenticated = false;
      state.isInitialized = false;
      localStorage.removeItem('auth');
      sessionStorage.clear();
      clearSessionTimeout();
    },
    setInitialized: (state, action) => {
      state.isInitialized = action.payload;
    },
    restoreAuth: (state) => {
      try {
        const stored = localStorage.getItem('auth');
        if (stored) {
          const parsed = JSON.parse(stored);
          // Add debug logging
          console.log('Restoring auth from storage:', parsed);
          
          if (parsed.user && parsed.isAuthenticated) {
            state.user = parsed.user;
            state.isAuthenticated = true;
            state.isInitialized = true;
            // Restart session timeout
            startSessionTimeout();
          }
        }
      } catch (error) {
        console.error('Failed to restore auth state:', error);
        // Clear potentially corrupted storage
        localStorage.removeItem('auth');
        state.user = null;
        state.isAuthenticated = false;
        state.isInitialized = true;
      }
    }
  },
});

export const { setUser, logOut, setInitialized, restoreAuth } = authSlice.actions;
export default authSlice.reducer;